import { useState, useEffect } from 'react';
import { Card, Button, LoadingSpinner } from '../components/Layout';
import api from '../services/api';

export function TrainingPage() {
  const [loading, setLoading] = useState(true);
  const [required, setRequired] = useState<any[]>([]);
  const [_available, setAvailable] = useState<any[]>([]);
  const [certifications, setCertifications] = useState<any[]>([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [req, avail, certs] = await Promise.all([
        api.getRequiredTraining(),
        api.getAvailableTraining(),
        api.getCertifications(),
      ]);
      setRequired(req || []);
      setAvailable(avail || []);
      setCertifications(certs || []);
    } catch (error) {
      console.error('Error loading training:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center p-8"><LoadingSpinner /></div>;
  }

  return (
    <div className="space-y-6">
      <Card>
        <h1 className="text-2xl font-bold text-white">Training Center</h1>
      </Card>

      {/* Required Training */}
      <Card>
        <h2 className="text-xl font-bold text-white mb-4">Required Training</h2>
        {required.length === 0 ? (
          <p className="text-gray-400 text-center py-4">All required training completed!</p>
        ) : (
          <div className="space-y-3">
            {required.map((training) => (
              <div key={training.id} className="bg-gray-700 p-4 rounded-lg">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="text-white font-medium">{training.title}</div>
                    {training.description && (
                      <div className="text-gray-400 text-sm mt-1">{training.description}</div>
                    )}
                  </div>
                  <Button size="sm">Start</Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>

      {/* My Certifications */}
      {certifications.length > 0 && (
        <Card>
          <h2 className="text-xl font-bold text-white mb-4">My Certifications</h2>
          <div className="space-y-3">
            {certifications.map((cert) => (
              <div key={cert.id} className="bg-gray-700 p-4 rounded-lg">
                <div className="text-white font-medium">{cert.title}</div>
                <div className="text-gray-400 text-sm mt-1">
                  Completed: {new Date(cert.completed_at).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}
